<template>
  <div>
    <H5>Файлы</H5>
    <list
      v-show="loadingStatus === true"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="false"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      @error="loadingStatus = false"
      @succress="loadingStatus = true"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/homework/${this.id}/media`;
    this.setLink = `business/homework/${this.id}/media`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          col: "col-12 col-md-12",
          key: "files",
          label: "Загрузите  файлы",
          type: "files",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "title",
          lang: true,
          checkbox: false,
        },
        {
          key: "file_name",
          title: "Название файла",
          checkbox: false,
        },
        {
          key: "path",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
